/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar30 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar30", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.941406 14.306641 C 12.503406 14.306641 13.578125 15.092469 13.578125 16.230469 C 13.578125 17.041469 13.035141 17.681125 12.244141 17.828125 L 12.244141 17.921875 C 13.216141 18.024875 13.837891 18.662312 13.837891 19.570312 C 13.836891 20.844312 12.634156 21.734375 10.910156 21.734375 C 9.2641563 21.734375 8.15675 20.835125 8.09375 19.453125 L 9.8027344 19.453125 C 9.8267344 19.990125 10.262406 20.322266 10.941406 20.322266 C 11.576406 20.322266 12.015625 19.961594 12.015625 19.433594 C 12.015625 18.891594 11.600016 18.560547 10.916016 18.560547 L 10.052734 18.560547 L 10.052734 17.324219 L 10.916016 17.324219 C 11.517016 17.324219 11.912109 16.987609 11.912109 16.474609 C 11.912109 15.961609 11.525391 15.644531 10.900391 15.644531 C 10.285391 15.644531 9.8715625 16.0105 9.8515625 16.5625 L 8.2265625 16.5625 C 8.2505625 15.1855 9.3054063 14.306641 10.941406 14.306641 z M 18.917969 14.308594 C 20.729969 14.308594 21.876953 15.665766 21.876953 18.009766 C 21.876953 20.333766 20.743969 21.734375 18.917969 21.734375 C 17.086969 21.734375 15.958984 20.337906 15.958984 18.003906 C 15.958984 15.669906 17.101969 14.308594 18.917969 14.308594 z M 18.917969 15.683594 C 18.233969 15.683594 17.779297 16.455906 17.779297 18.003906 C 17.779297 19.561906 18.233969 20.357422 18.917969 20.357422 C 19.601969 20.357422 20.060547 19.561906 20.060547 18.003906 C 20.060547 16.456906 19.601969 15.683594 18.917969 15.683594 z" />
      </svg>
    );
  }
}

IconCalendar30.defaultProps = {
  className: null
};

IconCalendar30.propTypes = {
  className: PropTypes.string
};

export default IconCalendar30;
